/* istanbul ignore file */
import styled from 'styled-components';

import { Icon, variables } from 'app/shared/ui';

const { zIndex } = variables;

const zIndexTradeIn = zIndex.modal + 100;

export const ModalSt = styled.div`
  position: fixed;
  z-index: ${zIndexTradeIn};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ModalContentSt = styled.div`
  position: relative;
  z-index: ${zIndexTradeIn};
  width: 100%;
  height: 100vh;
  padding: 64px 0 0;
  background-color: ${({ theme: { colors } }) => colors.white};
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ModalTopBarSt = styled.div`
  display: flex;
  flex-flow: row-reverse;
  align-items: center;
  position: fixed;
  z-index: ${zIndexTradeIn + 1};
  top: 0;
  left: 0;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  height: 64px;
  background-color: ${({ theme: { colors } }) => colors.brandSecondary};
  color: ${({ theme: { colors } }) => colors.white};
`;

export const IconCloseSt = styled(Icon)`
  font-size: 24px;
  color: ${({ theme: { colors } }) => colors.white};
  float: right;
`;

export const HighlightedSpan = styled.span`
  padding: 0 2px;
  background-color: ${({ backgroundColor, theme: { colors } }) =>
    backgroundColor || colors.sunbeanDark};
`;
